import React, {useState, useEffect} from 'react';
import { getComparator, stableSort } from './TableSorting';
import EnhancedTableHead from "./TableHead";
import { upvotePost } from "../../../firebase/writeData"
import { firebase } from "../../../firebase/firebaseConfig"
import { useAuthState } from 'react-firebase-hooks/auth'
import { useHistory } from 'react-router-dom';

//Material UI Imports
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Button } from 'react-bootstrap';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

var cloneDeep = require('lodash.clonedeep');

export default function EnhancedTable(props) {
  const classes = useStyles(); //Styling and controls
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('upvotes');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [user] = useAuthState(firebase.auth());
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(false);
  let history = useHistory();

  useEffect(() => {
    //Formatting row data
    let tempRows = [];
    props.posts.forEach((row) => {
      const {postID, authorID, authorName, authorProfile, date, summary, upvotes, upvoters} = row;
      const location = `${row.city}, ${row.region}, ${row.country}`;
      let textSectors;
      row.sector.forEach((sector, index) => {
        if (sector) {
          if (index === 0) {
            textSectors = sector;
          }
          else textSectors += `, ${sector}`;
        }
      }); 
      tempRows.push({postID, authorID, authorName, authorProfile, date, summary, upvotes, upvoters, location, sectors: textSectors});
    });
    setRows(tempRows);
    setPage(0);
  }, [props.posts]);

  
  //Sets table state on which property (column) is being sorted + up or downsort.
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleRowClick = (postID) => {
    history.push(`/forum/posts/${postID}`);
  }

  const handleUpvote = (postID, postUpvoters, summary) => {
    if (user) {
      if (postUpvoters.length !== 0 && postUpvoters[0] !== "" && postUpvoters.includes(user.uid)) {
        upvotePost({upvote: -1, authorID: user.uid, postID, postUpvoters, summary});
        const tempRows = cloneDeep(props.posts);
        tempRows.forEach(row => {
          if (row.postID === postID) {
            row.upvotes = row.upvotes - 1;
            row.upvoters = row.upvoters.filter(author => author !== user.uid);
          } 
        })
        props.setPosts(tempRows);
        firebase.analytics().logEvent('post_unvote');
      } else {
        upvotePost({upvote: 1, authorID: user.uid, postID, postUpvoters, summary});
        const tempRows = cloneDeep(props.posts);
        tempRows.forEach(row => {
          if (row.postID === postID) {
            row.upvotes = row.upvotes + 1;
            const newUpvoters = (row.upvoters && row.upvoters[0] !== "") ? [...row.upvoters, user.uid] : [user.uid];
            row.upvoters = newUpvoters;
          } 
        })
        props.setPosts(tempRows);
        firebase.analytics().logEvent('post_upvote');
      }
    } else {
      //Not logged in
      setError(true);
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let emptyRows;
  if (rows) emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            {/* Sorts rows. Then displays the rows that should be displayed on this page. */}
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  let formattedDate = row.date.toDateString();
                  formattedDate = formattedDate.substring(formattedDate.indexOf(" ") + 1);
                  let upvoted = false;
                  if (user && row.upvoters.length !== 0 && row.upvoters[0] !== "" && row.upvoters.includes(user.uid)) {
                    upvoted = true; }

                  //IMPORTANT PART -- CHANGING ROW CONTENT
                  return (
                    <TableRow
                      hover
                      className="table-row-pointer"
                      tabIndex={-1}
                      key={row.postID}
                    >
                      <TableCell component="th" scope="row" onClick={() => handleRowClick(row.postID)}>
                        {row.authorName}
                      </TableCell>
                      <TableCell align="left" onClick={() => handleRowClick(row.postID)}>{formattedDate}</TableCell>
                      <TableCell align="left" onClick={() => handleRowClick(row.postID)}>{row.summary}</TableCell>
                      <TableCell align="left" onClick={() => handleRowClick(row.postID)}>{row.sectors}</TableCell>
                      <TableCell align="left" onClick={() => handleRowClick(row.postID)}>{row.location}</TableCell>
                      <TableCell align="right" >
                        <Button variant={upvoted ? "success" : "outline-success"} onClick={() => handleUpvote(row.postID, row.upvoters, row.summary)}>
                          +{row.upvotes}
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <Snackbar 
        open={error} 
        autoHideDuration={3000} 
        onClose={() => setError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        key={'topcenter'}
        >
        <MuiAlert elevation={6} variant="filled" severity="error">
          Please sign in to upvote posts. 
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

//Random Styling
const useStyles = makeStyles((theme) => ({
  root: {
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 1200,
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    maxWidth: 1200,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));